import { c as _c } from "react/compiler-runtime";
import { EditableText as BaseEditableText, type EditableTextProps } from '@/components/block-primitives';
import { contextInlineMarkup } from '../inline-markup/context-inline-markup';

// Binds the investigation's kinds so the eleven block components don't each name a registry.
const EditableText = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <BaseEditableText {...props} registry={contextInlineMarkup} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default EditableText;